<template>
  <div>
    <div class="bg-white rounded  my-4 shadow-md px-4 md:px-6 py-2 overflow-hidden">
      <h2 class="text-gray-800 text-lg font-bold text-center uppercase">Příchod Slovanů</h2>
      <div>
        <p class="text-gray-800 text-base">
          Asi v 5. století n. l. přicházejí na naše území kmeny <strong>Slovanů</strong>. Jejich původní vlastí byla dnešní <strong>západní Ukrajina</strong> a <strong>východní Polsko</strong>.
          Slované postupně vytlačili Germány, kteří z našeho území buď odešli, nebo se Slovany postupně splynuli.
        </p>
        <p class="italic text-xs text-gray-700">
          Slovanské kmeny k nám přicházejí v době velkého přemísťování obyvatel, kterému říkáme <strong>stěhování národů</strong>. Pravděpodobnou příčinou stěhování Slovanů byly útoky kočovných kmenů
          z oblasti Asie. Tyto kmeny hledaly nové pastviny pro svůj dobytek, a vytlačovaly proto Slovany ze jejich původního území.
        </p>
        <p class="text-gray-800 text-base">
          První Slované na našem území byli <strong>pastevci</strong> a <strong>zemědělci</strong>. Usadili se v okolí vodních toků, pracovali na polích. Chovali vepře, kozy a ovce, lovili divoká
          zvířata a ryby. Dokázali <strong>tkát látky</strong>. Domy (chaty) stavěli ze dřeva, proutí a rákosu. Také nářadí měli převážně ze <strong> dřeva</strong>, železo bylo totiž drahé. Obyvatelé
          vesnic, provozovali <strong>výměnný obchod</strong>, to znamená, že si navzájem vyměňovali jeden druh zboží za jiný.
        </p>
        <p class="italic text-xs text-gray-700">
          Slovanské kmeny pravděpodobně hovořily společným jazykem, kterému říkáme <strong> praslovanština</strong>. Ta se nedochovala v písemné podoě, jazykovědcům se však podařilo dotvořit přibližné
          znění tehdejších slov.
        </p>
        <p class="text-gray-800 text-base">
          První Slované nevyznávali křesťanské náboženství, ale <strong>náboženství pohanské</strong>. Pohané neměli jediného boha. Uctívali <strong>mnoho bohů</strong>. Nejmocnějším z nich byl Perun
          - bůh války a zároveň vládce hromu a blesku - a Veles - bůh úrody.
        </p>
        <p class="italic text-xs text-gray-700">
          Příchodem Slovanů <strong>končí</strong> v našich zemích období dějin nazývané <strong>pravěk</strong>
          a začíná nové historické období označované jako středověk.
        </p>
        <img src="http://www.encyklopedie.ckrumlov.cz/img/7698.gif" alt="http://www.encyklopedie.ckrumlov.cz/docs/cz/mesto_histor_prstck.xml" />
        <p class="text-xs text-gray-600 hover:underline cursor-pointer"><a href="http://www.encyklopedie.ckrumlov.cz/docs/cz/mesto_histor_prstck.xml" target="_blank">Zdroj</a></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Slovane"
};
</script>

<style lang="scss" scoped></style>
